<template>
  <a-card :bordered="false">
    <!-- 标题区域 -->
    <div class="table-page-search-wrapper">
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <span style="font-size: 16px; font-weight: bold;">服务器MQ状态</span>
        <a-button type="primary" icon="reload" @click="loadData" :loading="loading">刷新列表</a-button>
      </div>
    </div>

    <!-- 表格区域 -->
    <div style="margin-top: 16px;">
      <a-table
        ref="table"
        bordered
        size="middle"
        rowKey="serverNo"
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="false"
      >
        <span slot="running" slot-scope="text">
          <a-tag :color="text ? 'green' : '#f5222d'" :style="text ? '' : 'color: #fff;'">
            {{ text ? '运行中' : '已停止' }}
          </a-tag>
        </span>
        <span slot="action" slot-scope="text, record">
          <a-popconfirm
            :title="record.running ? '确定要停止该MQ服务吗？' : '确定要启动该MQ服务吗？'"
            @confirm="handleToggleMq(record)"
            okText="确定"
            cancelText="取消"
          >
            <a-button
              v-if="record.running"
              type="danger"
              size="small"
              :loading="record.loading"
              style="background: #f5222d; border-color: #f5222d; color: #fff;"
            >停止</a-button>
            <a-button
              v-else
              type="primary"
              size="small"
              :loading="record.loading"
            >启动</a-button>
          </a-popconfirm>
        </span>
      </a-table>
    </div>
  </a-card>
</template>

<script>
import { getAction, postAction } from '@/api/manage'

export default {
  name: 'GisSyncMqList',
  data() {
    return {
      // 数据源
      dataSource: [],
      loading: false,
      // 表格列定义
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '服务器编号',
          align: 'center',
          dataIndex: 'serverNo',
          width: 150
        },
        {
          title: '主机地址',
          align: 'center',
          dataIndex: 'host',
          width: 200
        },
        {
          title: '运行状态',
          align: 'center',
          dataIndex: 'running',
          width: 120,
          scopedSlots: { customRender: 'running' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          align: 'center',
          width: 120
        }
      ],
      // API地址
      url: {
        list: '/log/mq/status',
        start: '/log/mq/start',
        stop: '/log/mq/stop'
      }
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    // 加载数据
    loadData() {
      this.loading = true
      getAction(this.url.list).then((res) => {
        if (res.success) {
          this.dataSource = res.result || []
        } else {
          this.$message.warning(res.message)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 切换MQ状态（启动/停止）
    handleToggleMq(record) {
      this.$set(record, 'loading', true)
      const apiUrl = record.running ? this.url.stop : this.url.start
      const params = { serverNo: record.serverNo }

      postAction(apiUrl, params).then((res) => {
        if (res.success) {
          this.$message.success(res.message || (record.running ? 'MQ已停止' : 'MQ已启动'))
          this.loadData()
        } else {
          this.$message.warning(res.message)
        }
      }).finally(() => {
        this.$set(record, 'loading', false)
      })
    }
  }
}
</script>

<style scoped>
</style>
